module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0059.jpg?v=a86735a5";